// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.broadcast-panel {
  display: flex;
  flex-direction: column;
  height: 150px;
  width: 230px;
}
.broadcast-panel .broadcast-panel-content {
  flex-grow: 1;
}
.broadcast-panel .broadcast-panel-content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}
.broadcast-panel .broadcast-panel-btn {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.broadcast-voice-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 150px;
  width: 320px;
}
.broadcast-voice-panel-title {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #222230;
}
.broadcast-voice-panel-warning {
  font-size: 14px;
  line-height: 20px;
  color: #361e00;
  text-align: center;
  padding: 6px;
  margin: 4px 0 10px;
  background: #fff9f2;
}
.broadcast-voice-panel-tip {
  font-size: 14px;
  line-height: 20px;
  color: #361e00;
  text-align: center;
  padding: 6px;
  margin: 4px 0 10px;
}
.broadcast-voice-panel-action {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.broadcast-voice-panel-action .ant-btn {
  border: none;
}
.broadcast-voice-panel-action .anticon {
  font-size: 40px;
}
.broadcast-voice-panel-action .anticon path {
  fill: #999;
}
.broadcast-voice-panel-action-stop .anticon path {
  fill: #f00;
}
.broadcast-voice-panel-action-live .anticon path {
  fill: #FFC470;
}`, "",{"version":3,"sources":["webpack://./src/feature/subsession/component/broadcast-panel.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AACF;AAAE;EACE,YAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAGN;AAAE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AAEF;AADE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAGJ;AADE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;AADE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAGJ;AADE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAGJ;AAFI;EACE,YAAA;AAIN;AAFI;EACE,eAAA;AAIN;AAHM;EACE,UAAA;AAKR;AAAQ;EACE,UAAA;AAEV;AAIQ;EACE,aAAA;AAFV","sourcesContent":[".broadcast-panel {\n  display: flex;\n  flex-direction: column;\n  height: 150px;\n  width: 230px;\n  .broadcast-panel-content {\n    flex-grow: 1;\n    textarea {\n      width: 100%;\n      height: 100%;\n      resize: none;\n    }\n  }\n  .broadcast-panel-btn {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n.broadcast-voice-panel{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 150px;\n  width: 320px;\n  &-title {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #222230;\n  }\n  &-warning {\n    font-size: 14px;\n    line-height: 20px;\n    color: #361e00;\n    text-align: center;\n    padding: 6px;\n    margin: 4px 0 10px;\n    background: #fff9f2;\n  }\n  &-tip {\n    font-size: 14px;\n    line-height: 20px;\n    color: #361e00;\n    text-align: center;\n    padding: 6px;\n    margin: 4px 0 10px;\n  }\n  &-action {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    & .ant-btn{\n      border: none;\n    }\n    & .anticon{\n      font-size: 40px;\n      & path{\n        fill: #999;\n      }\n    }\n    &-stop{\n      & .anticon{\n        & path{\n          fill: #f00;\n        }\n      }\n    }\n    &-live{\n      & .anticon{\n        & path{\n          fill: #FFC470;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
